import { foldInstallStatus } from '../../../../records/InstallMode/InstallStatus';
import resolveDialogCreateAppSpecificPassword from './DialogCreateAppSpecificPassword';
import resolveDialogShowAppSpecificPassword from './DialogShowAppSpecificPassword';
const resolveDialogAppSpecificPassword = _ref => {
  let {
    appSpecificPasswordInstallMode,
    closeInstallDialog,
    context,
    generateAppSpecificPassword,
    hostConfig,
    openManualUrlInstallDialog,
    openAppSpecificPasswordDialog,
    setAppSpecificPasswordName
  } = _ref;
  const createAppSpecificPassword = () => resolveDialogCreateAppSpecificPassword({
    appSpecificPasswordInstallMode,
    closeInstallDialog,
    context,
    generateAppSpecificPassword,
    hostConfig,
    openManualUrlInstallDialog,
    openAppSpecificPasswordDialog,
    setAppSpecificPasswordName
  });
  const showAppSpecificPassword = (name, installStatus) => resolveDialogShowAppSpecificPassword({
    name,
    closeInstallDialog,
    context,
    hostConfig,
    installStatus
  });
  return appSpecificPasswordInstallMode.appSpecificPassword.map(asp => foldInstallStatus(asp.status, createAppSpecificPassword, inProgress => showAppSpecificPassword(asp.name, inProgress), complete => showAppSpecificPassword(asp.name, complete))).getOrElseL(createAppSpecificPassword);
};
export default resolveDialogAppSpecificPassword;